import { navigationGraph, stepOrder } from './graph';
import type { NavigationContext, NavigationResult, StepId } from './types';
import { RefundRequestWizardStepIds } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/step-ids';

const resolveStepValue = (
  value: StepId | ((ctx: NavigationContext) => StepId | null),
  ctx: NavigationContext
): StepId | null => {
  return typeof value === 'function' ? value(ctx) : value;
};

const isStepIncluded = (stepId: StepId, ctx: NavigationContext): boolean => {
  const node = navigationGraph[stepId];
  if (!node) return false;

  if (!node.shouldInclude) return true;

  return node.shouldInclude(ctx);
};

export const getInitialStep = (ctx: NavigationContext): StepId => {
  for (const stepId of stepOrder) {
    if (isStepIncluded(stepId, ctx)) {
      return stepId;
    }
  }

  return RefundRequestWizardStepIds.CatalogForm;
};

export const resolveNavigation = (
  stepId: StepId,
  ctx: NavigationContext
): NavigationResult => {
  const node = navigationGraph[stepId];

  if (!node) {
    return { next: null, previous: null };
  }

  return {
    next: resolveStepValue(node.next, ctx),
    previous: resolveStepValue(node.previous, ctx),
  };
};

export const resolveNavigationWithOverride = (
  stepId: StepId,
  ctx: NavigationContext,
  valueOverrides: Partial<NavigationContext['values']>
): NavigationResult => {
  const overriddenCtx: NavigationContext = {
    ...ctx,
    values: { ...ctx.values, ...valueOverrides },
  };

  return resolveNavigation(stepId, overriddenCtx);
};
